import PropTypes from 'prop-types'

export const UserInterface = PropTypes.shape({
  id: PropTypes.number,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  avatar: PropTypes.string,
})
